import { useState, useEffect } from "react";
import SelectMultiple from "./SelectMultiple";
import { myPurposesTranslate } from "../../../../i18n/translatedMessages";

import { titlePurposeES, titlePurposeBR } from "./filter";
import { translate as purposeListTranslate } from "../../../../i18n/messages/Lists/purpose";

import "./purposeArea.sass";
import { useIntl } from "react-intl";

const PurposesArea = ({ myList, allPurposes, checkedList, name, handleChose, handlePopItem }) => {
  const lang = useIntl();
  const language = lang.locale === "PT-BR" ? "pt" : "es";
  const titlePurpose = lang.locale === "PT-BR" ? titlePurposeBR : titlePurposeES;
  const [candidatePurposes, setCandidatePurposes] = useState([]);
  const [allPurposesList, setAllPurposesList] = useState([]);

  const styles = {
    cursor: `url(${"https://assets.mydna.company/mydna_trash_icon.svg"}), auto`,
    // otros estilos si es necesario
  };

  useEffect(() => {
    setCandidatePurposes(myList.items);
    setAllPurposesList(allPurposes.items);
  }, [myList, allPurposes]);

  return (
    <div className="card purposeAreaEmployee-main mt-5">
      <div className="card-header">
        <h2 className="texto-body pt-1">{myPurposesTranslate.yourPurpose}</h2>
      </div>
      <div className="form-control area-checked">
        {candidatePurposes?.map((el, i) => {
          return (
            <span
              style={styles}
              onClick={() => {
                handlePopItem(el.id);
              }}
              key={el.purposeId}
            >
              {" "}
              {purposeListTranslate[language][el.name]}
            </span>
          );
        })}
      </div>
      <div className="row px-2 py-2">
        {titlePurposeES?.map((title, index) => {
          const itemsToRender = allPurposesList.filter((item) => item.purposeCategoryName === title);
          if (itemsToRender.length > 0) {
            return <SelectMultiple key={index} title={titlePurpose[index]} allPurposesList={itemsToRender} onClick={handleChose} />;
          } else {
            return null;
          }
        })}
        {/* {titlePurpose.length > 0 &&
                    titlePurpose.map((item, index) => (

                        <div className="col d-flex p-1" key={index}>
                            <SelectMultiple title={titlePurpose[index]} allPurposesList={allPurposesList} list={item} selectedList={checkedList} onClick={handleChose} />
                        </div>
                    ))} */}
      </div>
    </div>
  );
};
export default PurposesArea;
